// extracted by mini-css-extract-plugin
export default {"like":"styles_like__SVfV4","disabled":"styles_disabled__h-7NH","icon":"styles_icon__KE73d","liked":"styles_liked__RXf9n","likeButton":"styles_likeButton__j4Rzs"};